import { useState } from 'react';

import { send } from 'loot-core/platform/client/fetch';

import { useNavigate } from '../../../hooks/useNavigate';
import { theme } from '../../../style';
import { ButtonWithLoading } from '../../common/Button';
import { Input } from '../../common/Input';
import { Link } from '../../common/Link';
import { Text } from '../../common/Text';
import { View } from '../../common/View';
import { FormField, FormLabel } from '../../forms';

type ForgotPasswordProps = {
  onSwitchToSignin?: () => void;
};

const ForgotPasswordForm: React.FC<ForgotPasswordProps> = ({
  onSwitchToSignin,
}) => {
  const navigate = useNavigate();

  const [isEmailSent, setIsEmailSent] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    try {
      await send('subscribe-reset-password', {
        email,
      });
    } catch (e) {}
    setIsLoading(false);
    setIsEmailSent(true);
  }

  const navigateToSignin = () => {
    if (onSwitchToSignin) {
      onSwitchToSignin();
    } else {
      navigate('/login');
    }
  };

  return (
    <View>
      {isEmailSent ? (
        <Text style={{ padding: 8 }}>
          An email with password recovery instructions has been sent to your
          inbox. Please check your email.
        </Text>
      ) : (
        <View style={{ overflow: 'auto', padding: 8 }}>
          <form
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: 10,
            }}
            onSubmit={onSubmit}
          >
            <FormField style={{ flex: 1 }}>
              <View style={{ flexDirection: 'row' }}>
                <FormLabel title="Your email address" htmlFor="Email" />
                &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
              </View>
              <Input
                type="email"
                name="email"
                value={email}
                required={true}
                onChange={e => {
                  setEmail(e.target.value);
                }}
              />
            </FormField>
            <ButtonWithLoading disabled={isLoading} type="primary">
              Continue
            </ButtonWithLoading>
          </form>
          <div
            style={{
              margin: '16px 0 0',
              flexDirection: 'row',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            Go to&nbsp;
            <span>
              <Link
                variant="text"
                style={{ color: theme.pageTextLink, whiteSpace: 'nowrap' }}
                onClick={navigateToSignin}
              >
                Sign in
              </Link>
            </span>
          </div>
        </View>
      )}
    </View>
  );
};
export default ForgotPasswordForm;
